/**
 * 自定义链配置
 * 用于那些尚未被 viem/chains 收录的链
 */
export { kite } from "./kite";
export { bscTest } from "./bscTest";
